import { Card, Text, Menu } from "@mantine/core";
import React from "react";

export default function FlashcardSetCard(props) {
  const {
    setId,
    title,
    length,
    onCardClick,
    onEditClick,
    onDeleteClick,
  } = props;

  return (
    <Menu transition="rotate-right" shadow="md" width={200} offset={-10}>
      <Menu.Target>
        <Card className="setCard"
          style={{
            borderRadius: "10px",
            maxWidth: "300px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Text align="center" size="xl"weight={700}>{title}</Text>
          <Text>Number of cards: {length}</Text>
        </Card>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Deck Menu</Menu.Label>
        <Menu.Item onClick={() => onCardClick(length, setId)}>
          View Deck
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item onClick={() => onEditClick(setId)}>Edit Deck</Menu.Item>
        <Menu.Item color="red" onClick={() => onDeleteClick(setId)}>
          Delete Deck
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
